import { SETTING_CONFIG, STRING_CONFIG } from 'utils';
import * as actionType from './actionType';

const initialState = {
  activeIndex: 1,
  adTray: {
    amount: 0,
    show: true,
    status: null,
  },
  isModalOpen: false,
  location: {
    latitude: null,
    longitude: null,
    timestamp: null
  },
  mode: '',
  token: '',
  user: {},
  shopPref: {
    budget: [SETTING_CONFIG.default.shopPref.budgetMin, SETTING_CONFIG.default.shopPref.budgetMax],
    cCode: SETTING_CONFIG.default.shopPref.cCode,
    focusArea: 1,
    isFetched: false,
    releasedWithin: SETTING_CONFIG.default.shopPref.releasedWithinTwoYear,
    shopPrefUpdateCount: 1
  },
};
// eslint-disable-next-line default-param-last
export default (state = initialState, action) => {
  switch (action.type) {
    case actionType.ACTIVE_INDEX: {
      return {
        ...state,
        activeIndex: action.payload,
      };
    }
    case actionType.ARE_USER_PREFERENCE_FETCHED:
      return {
        ...state,
        shopPref: {
          ...state.shopPref,
          isFetched: action.payload
        }
      };
    case actionType.AUTH_MODAL: {
      return {
        ...state,
        isModalOpen: action.payload,
      };
    }
    case actionType.DELETE_PROFILE_IMAGE: {
      return {
        ...state,
        user: {
          ...state.user,
          image: null,
        },
      };
    }
    case actionType.SET_USER_LOCATION: {
      return {
        ...state,
        location: {
          latitude: action.payload.latitude,
          longitude: action.payload.longitude,
          timestamp: action.payload.timestamp ?? Date.now()
        }
      };
    }
    case actionType.SIGN_OUT: {
      return {
        ...state,
        mode: '',
        token: '',
        user: {},
        shopPref: { ...initialState.shopPref },
        location: { ...initialState.location }
      };
    }
    case actionType.TOKEN: {
      return {
        ...state,
        token: action.payload,
      };
    }
    case actionType.TRIAL_MODE: {
      return {
        ...state,
        mode: action.payload,
      };
    }
    case actionType.USER_DETAILS: {
      return {
        ...state,
        user: action.payload,
      };
    }
    case actionType.UPDATE_CATEGORY: {
      return {
        ...state,
        shopPref: {
          ...state.shopPref,
          categoryId: action.payload,
        },
      };
    }
    case actionType.UPDATE_PROFILE_IMAGE: {
      return {
        ...state,
        user: {
          ...state.user,
          ...action.payload,
        },
      };
    }
    case actionType.UPDATE_USER_PREFERENCE_BUDGET: {
      return {
        ...state,
        shopPref: {
          ...state.shopPref,
          ...action.payload,
        },
      };
    }
    case actionType.UPDATE_USER_DETAILS: {
      return {
        ...state,
        user: {
          ...state.user,
          firstName: action.payload.first_name,
          lastName: action.payload.last_name,
          phone: action.payload.phone,
        },
      };
    }
    case actionType.UPDATE_USER_PREFERENCE_FOCUS_AREA: {
      return {
        ...state,
        shopPref: {
          ...state.shopPref,
          ...action.payload,
        },
      };
    }
    case actionType.UPDATE_USER_PREFERENCE: {
      return {
        ...state,
        shopPref: {
          ...state.shopPref,
          ...action.payload,
        },
      };
    }
    case actionType.UPDATE_USER_PREFERENCE_RELEASED_WITHIN: {
      return {
        ...state,
        shopPref: {
          ...state.shopPref,
          ...action.payload,
        },
      };
    }
    case actionType.USER_PREFERENCE_UPDATED: {
      return {
        ...state,
        shopPref: {
          ...state.shopPref,
          shopPrefUpdateCount:
            state.shopPref.shopPrefUpdateCount + action.payload,
        },
      };
    }
    default: {
      return state;
    }
  }
};
